"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonUtility = require("../utils/commonUtility");

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _excluded = ["color", "children", "className", "bold", "italic", "style", "variant", "overflowEllipsis", "display", "align", "jss"];
var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    h1: (0, _extends2["default"])({}, theme.typography.h1, {
      color: theme.palette.text.dark
    }),
    h2: (0, _extends2["default"])({}, theme.typography.h2, {
      color: theme.palette.text.dark
    }),
    h3: (0, _extends2["default"])({}, theme.typography.h3, {
      color: theme.palette.text.dark
    }),
    h4: theme.typography.h4,
    h5: theme.typography.h5,
    h6: (0, _extends2["default"])({}, theme.typography.h6, {
      color: theme.palette.text.link
    }),
    h7: theme.typography.h7,
    h8: (0, _extends2["default"])({}, theme.typography.h8, {
      color: theme.palette.text.dark
    }),
    // deprecated
    running: theme.typography.running,
    // deprecated
    secondary: theme.typography.secondary,
    bold: {
      fontWeight: theme.typography.fontWeight.bold
    },
    italic: {
      fontStyle: theme.typography.fontStyle.italic
    },
    colorInput: {
      color: theme.palette.text.input
    },
    colorWhite: {
      color: theme.palette.text.white
    },
    colorDark: {
      color: theme.palette.text.dark
    },
    colorSecondary: {
      color: theme.palette.text.secondary
    },
    colorLink: {
      color: theme.palette.text.link
    },
    colorError: {
      color: theme.palette.error.text
    },
    colorSuccess: {
      color: theme.palette.success.text
    },
    colorAlert: {
      color: theme.palette.alert.text
    },
    colorInfo: {
      color: theme.palette.info.text
    },
    colorDefault: {
      color: theme.palette.text["default"]
    },
    colorLight: {
      color: theme.palette.text.light
    },
    colorPlaceholder: {
      color: theme.palette.text.placeholder
    },
    colorInherit: {
      color: 'inherit'
    },
    overflowEllipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    displayBlock: {
      display: 'block'
    },
    displayInline: {
      display: 'inline'
    },
    textCenter: {
      textAlign: 'center'
    },
    textRight: {
      textAlign: 'right'
    },
    textLeft: {
      textAlign: 'left'
    },
    textJustify: {
      textAlign: 'justify'
    }
  };
}, {
  name: 'TextField'
});
exports.useStyles = useStyles;

var TextField = /*#__PURE__*/_react["default"].forwardRef(function TextField(_ref, ref) {
  var _cn;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'initial' : _ref$color,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$bold = _ref.bold,
      bold = _ref$bold === void 0 ? false : _ref$bold,
      _ref$italic = _ref.italic,
      italic = _ref$italic === void 0 ? false : _ref$italic,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'inherit' : _ref$variant,
      _ref$overflowEllipsis = _ref.overflowEllipsis,
      overflowEllipsis = _ref$overflowEllipsis === void 0 ? false : _ref$overflowEllipsis,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? 'initial' : _ref$display,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'inherit' : _ref$align,
      _ref$jss = _ref.jss,
      jss = _ref$jss === void 0 ? {} : _ref$jss,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    jss: jss
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])((_cn = {}, (0, _defineProperty2["default"])(_cn, classes.overflowEllipsis, overflowEllipsis), (0, _defineProperty2["default"])(_cn, classes.bold, bold), (0, _defineProperty2["default"])(_cn, classes.italic, italic), (0, _defineProperty2["default"])(_cn, classes["color".concat((0, _commonUtility.firstLetterUppercase)(color))], color !== 'initial'), (0, _defineProperty2["default"])(_cn, classes[variant], variant !== 'inherit'), (0, _defineProperty2["default"])(_cn, classes["text".concat((0, _commonUtility.firstLetterUppercase)(align))], align !== 'inherit'), (0, _defineProperty2["default"])(_cn, classes["display".concat((0, _commonUtility.firstLetterUppercase)(display))], display !== 'initial'), _cn), 'text-field-wrapper', className),
    style: style
  }, props), children);
}); // Hack for withInfo plugin


TextField.displayName = 'TextField';
var _default = TextField;
exports["default"] = _default;